import * as types from '../actionTypes/systemParameter'

export function getSystemParameters(systemParameters) {
  return {
    type: types.GET_SYSTEM_PARAMETERS,
    systemParameters
  }
}

export function getFaqUrl(faqUrl) {
  return {
    type: types.GET_FAQ_URL,
    faqUrl
  }
}

export function getHomePageText(homePageText) {
  return {
    type: types.GET_HOME_PAGE_TEXT,
    homePageText
  }
}

export function getCandidateDetailsIntroText(candidateDetailsIntroText) {
  return {
    type: types.INTRO_TEXT_CANDIDATE_DETAILS,
    candidateDetailsIntroText
  }
}

export function getListOfCandidatesText(listOfCandidatesText) {
  return {
    type: types.LIST_OF_CANDIDATES_TEXT,
    listOfCandidatesText
  }
}

export function getStateGovtEmployeeLink(stateGovtEmployeeLink) {
  return {
    type: types.STATE_GOVT_EMPLOYEE_LINK,
    stateGovtEmployeeLink
  }
}

export function getQualificationsHelpText(qualificationsHelpText) {
  return {
    type: types.QUALIFICATIONS_HELPTEXT,
    qualificationsHelpText
  }
}

export function getSkillsExpertiseHelpText(skillsExpertiseHelpText) {
  return {
    type: types.SKILLS_EXPERTISE_HELPTEXT,
    skillsExpertiseHelpText
  }
}

export function getContactUsPageHtmlText(contactUsPageHtmlText) {
  return {
    type: types.CONTACT_US_PAGE_HTMLTEXT,
    contactUsPageHtmlText
  }
}

export function getDeclarationBodyText(declarationBodyText) {
  return {
    type: types.DECLARATION_BODY_TEXT,
    declarationBodyText
  }
}

export function getFaqForGeneralUsersHelpText(faqForGeneralUsersHelpText) {
  return {
    type: types.FAQ_FOR_GENERAL_USERS,
    faqForGeneralUsersHelpText
  }
}

export function getFaqForAuthorisedUsers(faqForAuthorisedUsers) {
  return {
    type: types.FAQ_FOR_AUTHORISED_USERS,
    faqForAuthorisedUsers
  }
}

export function getTitleHelpText(titleHelpText) {
  return {
    type: types.TITLE_HELPTEXT,
    titleHelpText
  }
}

export function getLinkedInLinkHelpText(linkedInLinkHelpText) {
  return {
    type: types.LINKEDIN_LINK_HELPTEXT,
    linkedInLinkHelpText
  }
}

export function getAnyCommentsHelpText(anyCommentsHelpText) {
  return {
    type: types.ANY_COMMENTS_HELPTEXT,
    anyCommentsHelpText
  }
}

export function getCommunicationsHelpText(communicationsHelpText) {
  return {
    type: types.COMMUNICATIONS_HELPTEXT,
    communicationsHelpText
  }
}

export function getGoogleAnalyticsTrackingCode(googleAnalyticsTrackingCode) {
  return {
    type: types.GOOGLE_ANALYTICS_TRACKING_CODE,
    googleAnalyticsTrackingCode
  }
}




// WEBPACK FOOTER //
// ./src/actions/systemParameter.js